<template>
  <div class="strategy-manager page-box">
    <query-header
      ref="header"
      @toQuery="toQuery"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              推送策略
            </vs-th>
            <vs-th>
              对应规则
            </vs-th>
            <vs-th>
              推送渠道
            </vs-th>
            <vs-th>
              推送人
            </vs-th>
            <vs-th>
              接收人
            </vs-th>
            <vs-th>
              消息ID
            </vs-th>
            <vs-th>
              推送状态
            </vs-th>
            <vs-th>
              状态备注
            </vs-th>
            <vs-th>
              推送时间
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
            >
              <vs-td>
                {{tr.id}}
              </vs-td>
              <vs-td>
                {{tr.strategyName}}
              </vs-td>
              <vs-td>
                {{tr.ruleName}}
              </vs-td>
              <vs-td>
                {{getChannelType(tr.channelType)}}
              </vs-td>
              <vs-td>
                {{tr.senderName || '-'}}
              </vs-td>
              <vs-td>
                {{tr.receiverName ? tr.receiverName : tr.receiverId}}
              </vs-td>
              <vs-td>
                {{tr.messageId || '-'}}
              </vs-td>
              <vs-td
                style="min-width: 100px"
              >
                <span
                  class="self-tag"
                  :style="getStatusStyle(tr)"
                >
                  {{tr.publishStatus == 0? "失败" : "成功"}}
                </span>
              </vs-td>
              <vs-td
                style="max-width: 400px"
              >
                {{ tr.failReason }}
              </vs-td>
              <vs-td>
                {{ parseTime(tr.publishTime) }}
              </vs-td>
              <vs-td>
                <el-button
                  v-if="tr.publishStatus == 0"
                  type="text"
                  class="theme-color"
                  @click.stop="doRepush(tr.id)"
                >重新推送</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import queryHeader from "@/components/wx/strategy-publish-log/queryHeader";
import { mapGetters } from 'vuex'
import { parseTime,colorRgba } from '@/utils'
import initData from "@/mixins/initData";
export default {
  name: "index",
  components: {
    queryHeader
  },
  data() {
    return {
      selected: [],
      red: '#D85E5F',
      green: '#41B883',
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/strategyPublishLog/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'publish_time',
        'order':'desc',
      }
      let header = this.$refs.header;
      if(header.strategyId){
        this.params.strategyId = header.strategyId;
      }
      if(header.channelType){
        this.params.channelType = header.channelType;
      }
      if(header.status !== ''){
        this.params.publishStatus = header.status;
      }
      if(header.rules !== ''){
        this.params.ruleId = header.rules;
      }
      if(header.pickerTime && header.pickerTime.length > 1 ){
        this.params.startTime = header.pickerTime[0];
        this.params.endTime = header.pickerTime[1];
      }

      return true;
    },
    doRepush(id){
      this.$http({
          url: `/wx/manage/strategyPublishLog/resend/`+id,
          method: 'put',
          data: {}
      }).then((data) => {
          if (data.code === 200) {
              this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                      
                  }
              });
              this.searchHandle();
          } else {
              this.$message.error(data.msg)
          }
      })
    },
    getStatusStyle(tr){
      if(tr.publishStatus){
        return {
          backgroundColor: colorRgba(this.green,.1),
          color: this.green,
        }
      }else {
        return {
          backgroundColor: colorRgba(this.red,.1),
          color: this.red,
        }
      }
    },
    getChannelType(channelType){
      switch (channelType) {
        case 1:
          return '公众号';
        case 2:
          return 'Telegram';
        case 3:
          return 'Lark应用';
        case 4:
          return '企业微信';
        case 5:
          return '个人微信';
        case 6:
          return 'Lark机器人';
        case 7:
          return '钉钉';
        case 8:
          return 'MT4';
        case 9:
          return 'Line';
        case 10:
          return 'QQ';
        default:
          break;
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.strategy-manager {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
